import React from 'react';

const PreviewVideo = ({videoUrl}) => {
    return                   <div className='lg:col-span-1'>
        <div className='rounded-lg overflow-hidden shadow-sm border border-gray-200'>
            <div className='aspect-w-9 aspect-h-16 max-w-sm mx-auto'>
                <video
                    src={videoUrl}
                    controls
                    className='w-full h-full object-cover'
                    preload='metadata'
                >
                    Your browser does not support the video tag.
                </video>
            </div>
        </div>
    </div>

};

export default PreviewVideo;
